import { IndexTerminology } from '@root/api';

/** Suffix of the wellbeing-worded sibling of an index-term i18n key, e.g. `HAPPINESS_INDEX_WI`. */
export const WELLBEING_KEY_SUFFIX = '_WI';

/**
 * Picks the i18n key to translate for a given index-term key, honoring the company's terminology.
 *
 * For a company on {@link IndexTerminology.Wellbeing} it returns `key + "_WI"` when that variant
 * exists in the bundle; otherwise (HAPPINESS, unset, or missing variant) it returns `key` unchanged
 * — an exact fallback that keeps existing companies' wording intact.
 *
 * Pure and side-effect free so it can be unit-tested without React or i18next.
 *
 * @param key         the base bundle key holding the happiness/HI wording
 * @param terminology the company's terminology (defaults handled by the caller)
 * @param variantExists predicate telling whether the `_WI` variant is present in the active bundle
 */
export const resolveTerminologyKey = (
    key: string,
    terminology: IndexTerminology,
    variantExists: (candidateKey: string) => boolean
): string => {
    if (terminology === IndexTerminology.Wellbeing) {
        const wellbeingKey = key + WELLBEING_KEY_SUFFIX;
        if (variantExists(wellbeingKey)) {
            return wellbeingKey;
        }
    }
    return key;
};
